import React, { useCallback, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { Form, Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";

const WalletStats = ({ wallet, isMenu, toggleMenu }: any) => {
  console.log(wallet);

  const [walletsData, setWalletsData] = React.useState(wallet);
  const [sendBtnModal, setSendBtnModal] = React.useState<boolean>(false);
  const [transactionType, setTransactionType] = useState<number>(1);

  const [recieveBtnModal, setReceiveBtnModal] = React.useState<boolean>(false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      moneda: "",
      address: false,
      wallet_address: "",
      network: "",
      dito_user: false,
      user_name: "",
      email_name: "",
      wallet_user_id: "",
    },
    validationSchema: Yup.object({
      moneda: Yup.string().required("Select a Coin"),
      address: Yup.string().optional(),
      wallet_address: Yup.string().required("Please Enter the Wallet Address"),
      network: Yup.string().required("Please Select the Network"),
      dito_user: Yup.string().optional(),
      user_name: Yup.string().required("Please Enter the User Name"),
      email_name: Yup.string().required("PleaseEnter the User Email"),
      wallet_user_id: Yup.string().required("Please Enter the Wallet ID"),
    }),
    onSubmit: (values) => {
      console.log("userObj");
    },
  });

  // Alternar modal Informativa
  const toggleSendModal = useCallback(() => {
    setSendBtnModal((prev) => !prev);
  }, []);
  return (
    <>
      <Card>
        <CardBody>
          <h3>Vista general</h3>
        </CardBody>
        <CardBody className="border-top">
          <Row>
            <Col sm="6">
              <div>
                <p className="text-muted mb-2">Available Balance</p>
                <h5>{wallet.availableBalance}</h5>
              </div>
            </Col>
            <Col sm="6">
              <div className="text-sm-end mt-4 mt-sm-0">
                <p className="text-muted mb-2">Since last month</p>
                <h5>
                  {wallet.lastMonthDifference}
                  <span className="badge bg-success ms-2 align-bottom">
                    {wallet.lastMonthDifferencePercent}
                  </span>
                </h5>
              </div>
            </Col>
          </Row>
        </CardBody>
        <CardBody className="border-top">
          <p className="text-muted mb-4">In this month</p>
          <div className="text-center">
            <Row>
              <Col sm="4">
                <div>
                  <div className="font-size-24 text-primary mb-2">
                    <i className="bx bx-send" />
                  </div>

                  <p className="text-muted mb-2">Send</p>
                  <h5>{wallet.send}</h5>

                  <div className="mt-3">
                    <Link
                      to="#"
                      className="btn btn-primary btn-sm w-md"
                      onClick={() => setSendBtnModal(true)}
                    >
                      Send
                    </Link>
                  </div>
                </div>
              </Col>
              <Col sm="4">
                <div className="mt-4 mt-sm-0">
                  <div className="font-size-24 text-primary mb-2">
                    <i className="bx bx-import" />
                  </div>

                  <p className="text-muted mb-2">receive</p>
                  <h5>{wallet.receive}</h5>

                  <div className="mt-3">
                    <Link to="#" className="btn btn-primary btn-sm w-md">
                      Receive
                    </Link>
                  </div>
                </div>
              </Col>

              {/* TODOD - Esta puede ser la funcion para hacer envios y retiros internos ya sea de nuestra wallet a otra wallet interna o a las tarjetas de la entidad */}
              <Col sm="4">
                <div className="mt-4 mt-sm-0">
                  <div className="font-size-24 text-primary mb-2">
                    <i className="bx bx-wallet" />
                  </div>

                  <p className="text-muted mb-2">Withdraw</p>
                  <h5>{wallet.withdraw}</h5>

                  <div className="mt-3">
                    <Link to="#" className="btn btn-primary btn-sm w-md">
                      Withdraw
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>

      {/* MODAL PARA AGREGAR O EDITAR */}

      <Modal isOpen={sendBtnModal} toggle={toggleSendModal} size="lg">
        <ModalHeader toggle={toggleSendModal} tag="h4">
          {" "}
          {"Enviar a"}{" "}
        </ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              console.log("Send");
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                {/* Moneda */}
                <Row className="mb-3">
                  <Label className="col-md-2 col-form-label">Moneda</Label>
                  <div className="col-md-10">
                    <Input
                      type="select"
                      name="moneda"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.moneda || ""}
                    >
                      <option value="" selected disabled>
                        Select Coin
                      </option>
                      <option key="BTC" value="BTC">
                        Bitcoin
                      </option>
                      <option key="USDC" value="USDC">
                        USDC
                      </option>
                    </Input>
                  </div>
                </Row>
                {/* BALANCE */}
                <Row className="mb-3">
                  <Label>Seleccione se el tipo de transaccion</Label>
                  <div className="btn-group" role="group">
                    {/* Opción Fiat */}
                    <input
                      type="radio"
                      className="btn-check"
                      name="currency"
                      id="btnFiat"
                      autoComplete="off"
                      value="Fiat"
                      checked={transactionType === 1}
                      onChange={() => setTransactionType(1)}
                    />
                    <label className="btn btn-secondary" htmlFor="btnFiat">
                      Address
                    </label>

                    {/* Opción Crypto */}
                    <input
                      type="radio"
                      className="btn-check"
                      name="currency"
                      id="btnCrypto"
                      autoComplete="off"
                      value="Crypto"
                      checked={transactionType === 2}
                      onChange={() => setTransactionType(2)}
                    />
                    <label className="btn btn-secondary" htmlFor="btnCrypto">
                      Dito User
                    </label>
                  </div>
                </Row>

                {transactionType === 1 ? (
                  <>
                    <div className="mb-3">
                      {/* Nombre de la entidad */}
                      <Label>Moneda Cripto</Label>
                      <Input name="name" type="text" value={""} />
                    </div>
                    <div className="mb-3">
                      {/* Direccion de Address */}
                      <Label>Direccion de Wallet</Label>
                      <Input name="name" type="text" value={""} />
                    </div>
                  </>
                ) : (
                  <div>
                    {/* Nombre */}
                    <div className="mb-3">
                      <Label>Nombre del Usuario</Label>
                      <Input name="name" type="text" value={""} />
                    </div>
                    {/* Correo */}
                    <div className="mb-3">
                      <Label>Correo</Label>
                      <Input name="name" type="text" value={""} />
                    </div>
                    {/* Monto */}
                    <div className="mb-3">
                      <Label>Monto</Label>
                      <Input name="name" type="text" value={""} />
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end mt-4">
                  <Button type="submit" color="success" className="save-user">
                    {" "}
                    {"Send"}{" "}
                  </Button>
                </div>
              </Col>
            </Row>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default WalletStats;
